/*
 *   Copyright (c) 2026 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const VERIFY_TICKET_PAYMENT = gql`
  mutation VerifyTicketPayment($txId: String!) {
    verifyTicketPayment(txId: $txId) {
      txId
      status
      syncStatus
      resolutionStatus
      amount
      ticketAmount
      convenienceFee
      currency
      paymentMode
      costumeStatus
      ticketOrder {
        ticketOrderId
        status
        releaseReason
        holdExpiresAt
        tickets {
          ticketId
          tierId
          tierName
        }
        viewTicketsUrl
      }
    }
  }
`;
